// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e5f191eb","977":"4eb59aad"}[chunkId] + ".chunk.js";
};